import React, { useMemo } from "react";

import { EventOffer, SportOffer } from "@gp/offer";
import { SportAbrv } from "@utils";
import { HALF_TIME_SPORTS } from "@utils/offer/event-result/HalfTimeSport";
import { PERIOD_SPORTS } from "@utils/offer/event-result/PeriodSports";
import { withoutOvertimeAndPenalties } from "@utils/offer/offerHistoryScore";
import { observer } from "mobx-react";

import {
	Corners,
	FullTimeScore,
	GameScore,
	HalfTimeScore,
	PeriodScores,
	RedCards,
	YellowCards,
} from ".";

export default observer(function HistoryEventCurrentStats({
	event,
	sport,
}: {
	event: EventOffer;
	sport: SportOffer;
}) {
	const {
		isSoccer,
		isTennis,
		isHalfTimeSport,
		isPeriodSport,
		isQuarterSport,
	} = useMemo(
		() => ({
			isSoccer: sport?.abrv === SportAbrv.SOCCER,
			isTennis: sport?.abrv === SportAbrv.TENNIS,
			isHalfTimeSport: HALF_TIME_SPORTS.has(sport?.abrv),
			isPeriodSport: PERIOD_SPORTS.has(sport?.abrv),
			isQuarterSport: sport?.abrv === SportAbrv.BASKETBALL,
		}),
		[sport?.abrv]
	);

	const homeStats = event.result?.homeTeamTotalStatistics;
	const awayStats = event.result?.awayTeamTotalStatistics;
	const periodScores = withoutOvertimeAndPenalties(
		event.result?.scorePerPeriod
	);

	return (
		<div className="event__stats event__stats--history">
			{isSoccer && (
				<>
					<Corners homeStats={homeStats} awayStats={awayStats} />
					<RedCards homeStats={homeStats} awayStats={awayStats} />
					<YellowCards homeStats={homeStats} awayStats={awayStats} />
				</>
			)}

			{isHalfTimeSport && event.result?.halfTimeScore && (
				<HalfTimeScore
					halfTimeScore={event.result.halfTimeScore}
					labelKey="OFFER_HISTORY.HT"
				/>
			)}

			{(isPeriodSport || isQuarterSport) && periodScores && (
				<PeriodScores scoresPerPeriod={periodScores} />
			)}

			{event.result?.fullTimeScore && (
				<FullTimeScore fullTimeScore={event.result.fullTimeScore} />
			)}

			{isTennis && <GameScore event={event} sport={sport} />}
		</div>
	);
});
